<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red">*</span>药品名称
    </div>
    <el-input
      id="selectRole"
      maxlength="50"
      show-word-limit
      placeholder="请输入名称"
      v-model="input"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "encyclopedia",
  props:['encyclopediaName'],
  computed: {
    input: {
      get() {
        return this.encyclopediaName
      },
      set(val) {
        this.$emit('update:encyclopediaName',val)
      }
    }
  },
}
</script>

<style scoped>

</style>
